module.exports = __webpack_public_path__ + "static/media/speakers_logos_SIEMENS.8361f6ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_SIEMENS.jpg
// module id = 278
// module chunks = 0